export default __webpack_public_path__ + "static/media/CFD229.2b7981b6.jpg";